import useLenis from "../hooks/useLenis";
import useSeo from "../hooks/useSeo";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Ticker } from "../components/Ticker";
import { Problems } from "../components/Problems";
import { Manifesto } from "../components/Manifesto";
import { Solution } from "../components/Solution";
import { Industries } from "../components/Industries";
import { TrustReach } from "../components/TrustReach";
import { Proof } from "../components/Proof";
import { Recognition } from "../components/Recognition";
import { CaseStudiesTeaser } from "../components/CaseStudiesTeaser";
import { ImpactDashboard } from "../components/ImpactDashboard";
import { ROICalculator } from "../components/ROICalculator";
import { LeadForm } from "../components/LeadForm";
import { Footer } from "../components/Footer";

export default function Landing() {
  useLenis();
  useSeo({
    title: "Fresh Earth · OED — Biological Landfill & Organic-Waste Remediation in India",
    description:
      "Eliminate landfill odour, accelerate decomposition and restore biological activity with OED — a scalable indigenous microbial solution. Deployed across 15 municipal corporations.",
    path: "/",
  });
  return (
    <div className="bg-bone text-ink" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <Problems />
        <Manifesto />
        <Solution />
        <Industries />
        <TrustReach />
        <Proof />
        <Recognition />
        <CaseStudiesTeaser />
        <ImpactDashboard />
        <ROICalculator />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}
